import { ApiCrud } from './api-crud';
import http from './http';
import { Organization } from '../model/organization';

const organizationApi = new ApiCrud(http.AXIOS, Organization, 'organizations');


export default organizationApi;
